import { render, staticRenderFns } from "./PurchaseOrderDetails.vue?vue&type=template&id=74187cea&scoped=true&"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetails.vue?vue&type=style&index=0&id=74187cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74187cea",
  null
  
)

export default component.exports